import { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { listContractUiChanges } from "./contractUiRealtime";

const cap = (s) => `${s[0].toUpperCase()}${s.slice(1)}`;

// Tells the buyer, as it happens, what the seller has just changed on the contract page. Only
// changes that arrive while this page is open are announced: what was already there when the page
// opened is simply shown, as the saved values.
export default function useContractChangeNotices(messages, t) {
  const seen = useRef(null);
  useEffect(() => {
    const changes = listContractUiChanges(messages);
    if (seen.current === null || changes.length < seen.current) {
      seen.current = changes.length;
      return;
    }
    changes.slice(seen.current).forEach(({ field, value }) => {
      let text;
      if (field === "odometer" || field === "keysCount") text = t(`contractUi.notice.${field}`, { value });
      else if (field === "debt") text = t("contractUi.notice.debt", { option: t(`buyer.debts${cap(String(value?.option || "none"))}`) });
      else if (field === "loan") text = t("contractUi.notice.loan", { option: t(`buyer.loan${cap(String(value?.option || "none"))}`) });
      else text = t(`contractUi.notice.${field}`);
      toast.info(text, { autoClose: 8000, closeOnClick: true, toastId: `${field}:${seen.current}:${changes.length}` });
    });
    seen.current = changes.length;
  }, [messages, t]);
}
